import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Box, Grid, Button } from '@mui/material';
import {
  TextInput,
  FileUploadContract,
  ComboBox,
  ArrayInput,
  Selection,
  SimpleComboBox,
} from 'components';
import Utils from 'commons/utils';
import { PHONE_REG_EXP } from 'commons/constants';
import ApiServices from 'services';
import { SEX, RESPONSE_STATUSES } from 'commons/constants';

const SEX_OPTIONS = [
  { value: 0, content: SEX[0] },
  { value: 1, content: SEX[1] },
];

const CreateForm = ({
  clientCareHistoryItem,
  clientInformationDetail,
  onCloseModal,
  reloadData,
}) => {
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [sex, setSex] = useState('');
  const [nationality, setNationality] = useState('');
  const [religion, setReligion] = useState('');
  const [birthday, setBirthday] = useState(null);
  const [arrAddress, setArrAddress] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [fax, setFax] = useState('');
  const [email, setEmail] = useState('');

  const [file, setFile] = useState([]);
  const [currentFile, setCurrentFile] = useState([]);

  const handleChangeCode = useCallback(
    (e) => {
      setCode(e.target.value);
    },
    [code],
  );
  const handleChangeName = useCallback(
    (e) => {
      setName(e.target.value);
    },
    [name],
  );
  const handleChangeSex = useCallback(
    (e) => {
      setSex(e.target.value);
    },
    [sex],
  );
  const handleChangeNationality = useCallback(
    (e) => {
      setNationality(e.target.value);
    },
    [nationality],
  );
  const handleChangeReligion = useCallback(
    (e) => {
      setReligion(e.target.value);
    },
    [religion],
  );
  const handleChangeBirthday = useCallback(
    (e) => {
      setBirthday(e.target.value);
    },
    [birthday],
  );
  const handleChangeArrAddress = useCallback(
    (e) => {
      setArrAddress(e.target.value);
    },
    [arrAddress],
  );
  const handleChangePhoneNumber = useCallback(
    (e) => {
      setPhoneNumber(e.target.value);
    },
    [phoneNumber],
  );
  const handleChangeFax = useCallback(
    (e) => {
      setFax(e.target.value);
    },
    [fax],
  );
  const handleChangeEmail = useCallback(
    (e) => {
      setEmail(e.target.value);
    },
    [email],
  );

  const handleChangeFile = useCallback(
    (e) => {
      setFile(e.target.value);
    },
    [file],
  );
  const handleChangeCurrentFile = useCallback(
    (fileCurrent) => {
      setCurrentFile(fileCurrent || []);
    },
    [currentFile],
  );

  const handleSubmit = async () => {
    if (!name) {
      window.UIMessage?.error('Vui lòng chọn Tên người liên hệ');
      return;
    }
    if (!sex && sex !== 0) {
      window.UIMessage?.error('Vui lòng chọn Giới tính');
      return;
    }

    if (!phoneNumber && !fax && file?.length < 1) {
      window.UIMessage?.error(
        'Vui lòng nhập dữ liệu cho 1 trong 3 mục sau:',
        'Số điện thoại, Ứng dụng liên hệ, File dữ liệu',
        5000,
      );
      return;
    }

    setLoading(true);

    const dataSend = {
      // code,
      fullName: name,
      sex,
      nationality,
      religion,
      birthday,
      arrAddress,
      phoneNumber,
      fax,
      email,
      clientCompanyId: clientInformationDetail?.id,
    };
    if (file?.length) {
      let tmp = file.map(([item]) => item);
      dataSend.files = tmp;
    }
    if (!dataSend.birthday) {
      delete dataSend.birthday;
    }

    try {
      const res = await ApiServices.createClientNew(dataSend);
      if (res.status === RESPONSE_STATUSES.OK) {
        window.UIMessage?.success('Thêm mới thành công');
        onCloseModal();
        reloadData();
      }
    } catch (error) {
      window.UIMessage?.error('Thêm mới thất bại !!!');
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Grid container spacing={1}>
        {/* <Grid item xs={6} sm={6} md={6}>
          <TextInput
            required
            error={!code}
            helperText={!code && 'Vui lòng nhập Mã người liên hệ'}
            label="Mã"
            name="code"
            onChange={handleChangeCode}
            value={code}
          />
        </Grid> */}
        <Grid item xs={6} sm={6} md={6}>
          <TextInput
            required
            error={!name}
            helperText={!name && 'Vui lòng nhập Tên người liên hệ'}
            label="Tên người liên hệ"
            name="name"
            onChange={handleChangeName}
            value={name}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          <TextInput label="Khách hàng" name="client" value={clientInformationDetail.name} />
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          <Selection
            required
            error={!sex && sex !== 0}
            helperText={!sex && sex !== 0 && 'Vui lòng nhập Giới tính'}
            label="Giới tính"
            name="sex"
            onChange={handleChangeSex}
            value={sex}
            dataArrObject={SEX_OPTIONS}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          <TextInput
            label="Quốc tịch"
            name="nationality"
            onChange={handleChangeNationality}
            value={nationality}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          <TextInput
            label="Tôn giáo"
            name="religion"
            onChange={handleChangeReligion}
            value={religion}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          <TextInput
            label="Năm sinh"
            name="birthday"
            onChange={handleChangeBirthday}
            value={birthday}
            type="date"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item xs={6} sm={6} md={6}>
          <TextInput
            label="Số điện thoại"
            name="phoneNumber"
            onChange={handleChangePhoneNumber}
            value={phoneNumber}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          <TextInput label="Ứng dụng liên hệ" name="fax" onChange={handleChangeFax} value={fax} />
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          <TextInput label="Email" name="email" onChange={handleChangeEmail} value={email} />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <ArrayInput
            value={arrAddress}
            fullWidth
            onChange={handleChangeArrAddress}
            label="Địa chỉ"
            name="arrAddress"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <FileUploadContract
            sortFileName={true}
            label="File ứng dụng"
            name="file"
            onChange={handleChangeFile}
            value={file}
            multiple={true}
            isUploadOnlyContract={true}
            valueCurrent={currentFile}
            onChangeCurrent={handleChangeCurrentFile}
          />
        </Grid>
      </Grid>
      <Box sx={{ py: 2, display: 'flex' }}>
        <Button
          color="primary"
          style={{
            marginLeft: 'auto',
            padding: '6px 30px',
          }}
          size="small"
          variant="contained"
          onClick={handleSubmit}
        >
          Thêm mới
        </Button>
      </Box>
    </Box>
  );
};

export { CreateForm };
